import styled from 'styled-components';
import { colors } from 'styles/colors';
import { shadows } from 'styles/remoteControlShadows';
import { MAX_WIDTH_BAR } from '../../constants';
import { responsiveWidthBarByCategory } from '../../helpers';
import { EfficiencyCategory } from '../../types';

interface EfficiencyBarProps {
  color: string,
  width: number,
  category: EfficiencyCategory,
  disabled: boolean
}

export const EnergyEfficiencyContainer = styled.div`
  width: 100%;
`;

export const EfficiencyBar = styled.div<EfficiencyBarProps>`
  margin-left: 16px;
  background-color: ${({ color, disabled }) => (disabled ? colors.icon['disabled-300'] : color)};
  width: ${({ width }) => width}px;
  height: 14px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  color: ${colors.text['main-900']};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')} !important;

  @media (max-width: 768px) {
    width: ${({ category }) => responsiveWidthBarByCategory(category)};
    max-width: ${MAX_WIDTH_BAR}px;
  }

`;

export const EfficiencyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const EfficiencyRowInfoContainer = styled.div`
  display: flex;
  width: 62px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: start;
  padding-left: 12px;
  padding-right: 16px;
  border-right: 1px solid ${colors.stroke['soft-200']};

  h4 {
    margin: 0;
    color: ${colors.text['main-900']};
    font-size: 14px;
    font-weight: 700;
    text-align: right;
    line-height: 150%;
  }

  span {
    color: ${colors.text['soft-400']};
    font-size: 10px;
    font-weight: 400;
    text-align: right;
    line-height: 150%;
    white-space: nowrap;
  }
`;

export const EfficiencyTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  tr {
    border-bottom: 1px solid ${colors.stroke['soft-200']};
  }

  tr:last-child {
    border-bottom: none;
  }

  td {
    padding: 0;
    height: 36px;
  }

  .tooltip-efficiency {
    max-width: 400px;
    opacity: 1 !important;
    padding: 0 !important;
    color: ${colors.text['main-900']};
    box-shadow: ${shadows.shadow01};
    background-color: ${colors.bg['weak-100']};
  }

  button {
    padding: 0;
    margin: 0;
    border: none;
    background-color: transparent;
    width: 100%;
    cursor: pointer;
  }

  button:focus {
    outline: 0;
  }

  button:disabled {
    cursor: default;
  }
`;
